<template>
    <div class="ProcessSubview">
        <QCard
            bordered
            class="ProcessSubviewCard"
        >
            <QCardSection>
                <SettingsModal :categoricalAttributes="categoricalAttributes" />
            </QCardSection>
        </QCard>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import SettingsModal from '../Settings/SettingsModal.vue'

export default {
    name: 'SettingsSubview',
    components: { SettingsModal },
    props: {
        categoricalAttributes: VueTypes.any,
    },
}
</script>

<style scoped lang="scss">
.ProcessSubview {
    height: 100%;
}

.ProcessSubviewCard {
    height: 100%;
}
</style>
